import { VariantType } from '../babylonjs/type/backendType'
import { IColor } from '../babylonjs/type/modelType'

export const colors = [
  '#ffffff',
  '#000000',
  '#5c9090',
  '#0f4c81',
  '#e9b666',
  '#edcabe',
  '#a5b2b5',
  '#c9cba3',
  '#e26d5c',
  '#472d30',
]

export const colorLibrary: IColor[] = [
  { id: 'warm-white', title: 'Warm white', hex: '#cccccc' },
  { id: 'black', title: 'Black', hex: '#000000' },
  { id: 'olive', title: 'Olive', hex: '#5c9090' },
  { id: 'blue', title: 'Blue', hex: '#0f4c81' },
  { id: 'yellow', title: 'Yellow', hex: '#e9b666' },
  { id: 'gray', title: 'Gray', hex: '#a5b2b5' },
  { id: 'soft-green', title: 'Soft green', hex: '#c9cba3' },
  { id: 'orange', title: 'Orange', hex: '#e26d5c' },
  {
    id: 'black-metal',
    title: 'Black metallic',
    hex: '#000000',
    metallic: 0.5,
    roughness: 0,
  },
  {
    id: 'smoke-red-metal',
    title: 'Smoke red metallic',
    hex: '#840000',
    metallic: 0.5,
    roughness: 0,
  },
  {
    id: 'dark-blue-metal',
    title: 'Dark blue metallic',
    hex: '#007684',
    metallic: 0.5,
    roughness: 0,
  },
  {
    id: 'dark-brown-metal',
    title: 'Dark brown metallic',
    hex: '#361E00',
    metallic: 0.5,
    roughness: 0,
  },
].map(c => ({ ...c, variantType: VariantType.COLOR }))

export const colorsLibSet1: IColor[] = [
  ...colorLibrary.filter(c =>
    [
      'warm-white',
      'black',
      'olive',
      'blue',
      'yellow',
      'gray',
      'soft-green',
      'orange',
    ].includes(c.id)
  ),
]

export const colorsLibSet2: IColor[] = [
  ...colorLibrary.filter(c =>
    [
      'black-metal',
      'smoke-red-metal',
      'dark-blue-metal',
      'dark-brown-metal',
    ].includes(c.id)
  ),
]
